/* Copyright (c) 2017 Backpack Health LLC */
/* global window */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { actions as localeActions } from '../../../redux/ducks/locale';

import { Title2 } from '../../../components/Text';

import IconLock from '../../../components/icons/IconLock';
import COLORS from '../../../styles/Colors';
import { LargePreferredLanguageDropdownList } from '../../../components/LanguageDropdownList';

import './PasscodeEntry.scss';
import PublicShareCardFooter from '../PublicShareCard/PublicShareCardFooter';

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    setWindowTitlePhrase: (phrase) => {
      dispatch(localeActions.setWindowTitlePhrase([phrase]));
    },
  };
}

interface Props {
  onRetry(): void;
  setWindowTitlePhrase(phrase: object): void;
}

class Inactive extends React.Component<Props, {}> {

  UNSAFE_componentWillMount() {
    this.props.setWindowTitlePhrase({ id: 'shareCardURLTimeout.page.title' });
  }

  render() {
    return (
      <div className="page-passcode">

        <div className="page-passcode-controls">
          <LargePreferredLanguageDropdownList htmlId="pageLanguage" color="white" />
        </div>

        <div className="page-passcodemain">
          <div className="page-passcodemain-header">
            <div className="page-passcodemain-lock">
              <IconLock.Medium fill={COLORS.gsMiddleLT} />
            </div>
          </div>

          <div className="page-passcodemain-content font-color-white" style={{ textAlign: 'center' }}>
            <Title2>
              <FormattedMessage id="shareCardURLTimeout.message.text" />
            </Title2>

            <button onClick={this.props.onRetry} className="cmp-passcodeinput-button">
              <Title2>
                <FormattedMessage id="shareCardURLTimeout.reEnterAccessCode.button.label" />
              </Title2>
            </button>
          </div>
        </div>

        <PublicShareCardFooter white/>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Inactive);
